import { useQuery } from '@apollo/client'
import apiKeysBySubnetGql from '../../gql/apiKey/apiKeysBySubnet.gql'

export const useApiKeysBySubnetService = ({ id }: { id: string }) => {
    const { data, error, loading, refetch } = useQuery(apiKeysBySubnetGql, {
        variables: { id },
        skip: !id,
        fetchPolicy: 'cache-and-network',
    })

    return {
        data: data?.getApiKeys || [],
        error,
        loading,
        refetch,
    }
}
